<template>
  <div>
    <Hospital></Hospital>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const Hospital = defineAsyncComponent(() =>
  import("@/components/hospitals/AllHospitals")
);
export default {
  components: {
    Hospital,
  },
};
</script>
